import React, { useEffect, useState } from 'react';
import { GlobeIcon, ZapIcon } from 'lucide-react';
const STORAGE_KEY = 'tennis-ready-launch-deadline';
const DAY_IN_MS = 24 * 60 * 60 * 1000;
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export function AnnouncementBar() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const stored = Number(window.localStorage.getItem(STORAGE_KEY));
    let deadline = Number.isFinite(stored) && stored > Date.now() ? stored : Date.now() + DAY_IN_MS;
    window.localStorage.setItem(STORAGE_KEY, String(deadline));
    const update = () => {
      const now = Date.now();
      if (deadline <= now) {
        deadline = now + DAY_IN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(deadline));
      }
      const totalSeconds = Math.max(0, Math.ceil((deadline - now) / 1000));
      setTimeLeft({
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor(totalSeconds % 3600 / 60),
        seconds: totalSeconds % 60
      });
    };
    update();
    const interval = window.setInterval(update, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <div className="fixed inset-x-0 top-0 z-50 bg-tr-navy" data-id="element-18" data-mp="3shb1dzzyko0w">
      <div className="relative mx-auto flex h-9 max-w-container items-center justify-center gap-3 px-4 pr-12" data-id="element-19" data-mp="18dse345b5qt">
        <p className="flex items-center gap-1.5 whitespace-nowrap text-[10px] font-semibold uppercase tracking-[0.12em] text-white sm:text-[11px]" data-id="element-20" data-mp="p02ntsc9kabz">
          <ZapIcon className="h-3 w-3 shrink-0 text-tr-orange" aria-hidden="true" data-id="element-21" data-mp="f8y98tqi2rho" />
          Launch offer ends in:
        </p>
        <p className="flex items-baseline gap-1 tabular-nums text-white" aria-label={`${timeLeft.hours} hours, ${timeLeft.minutes} minutes and ${timeLeft.seconds} seconds remaining`} data-id="element-22" data-mp="k6gk4po2vgsb">
          <TimerUnit value={timeLeft.hours} label="hrs" data-id="element-23" data-mp="1cpn94hvw3jof" />
          <span className="text-[11px] font-bold text-white/50" aria-hidden="true" data-id="element-24" data-mp="1mkkpuvd88vf8">
            :
          </span>
          <TimerUnit value={timeLeft.minutes} label="min" data-id="element-25" data-mp="1hmj7kcnml04t" />
          <span className="text-[11px] font-bold text-white/50" aria-hidden="true" data-id="element-26" data-mp="1clv4utq1auur">
            :
          </span>
          <TimerUnit value={timeLeft.seconds} label="sec" data-id="element-27" data-mp="18l2yq9cgl62p" />
        </p>
        <button type="button" className="absolute right-3 flex items-center gap-1 rounded-full px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-white/70 transition-colors duration-150 ease-out hover:text-white focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white" aria-label="Change language, current language English" data-id="element-28" data-mp="13lghlotif5om">
          <GlobeIcon className="h-3 w-3" aria-hidden="true" data-id="element-29" data-mp="kuz3oqdc6enb" />
          EN
        </button>
      </div>
    </div>;
}
function TimerUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="whitespace-nowrap text-[12px] font-bold sm:text-[13px]" data-id="element-30" data-mp="2rj7t06a7g2gr">
      {String(value).padStart(2, '0')}
      <span className="ml-0.5 text-[9px] font-semibold uppercase tracking-[0.08em] text-white/60" data-id="element-31" data-mp="2whsu07xa6q69">
        {label}
      </span>
    </span>;
}